export interface IDeletePersonaModeloEquipo {
  personaId: string;
  equipoModeloId: string;
}

export interface IFilterTableAutorizacionModeloPorPersona {
  skip: number
  take: number,
  search: string| undefined
  personaId: string | undefined
}

export const initialFilterTableAutorizacionModeloPersona ={
  skip: 0,
  take: 50,
  search: '',
  personId: ''
}